<template>
  <div class="py-4 container-fluid">
    <div class="row">
      <div class="col-12">
        <businesslocation-form></businesslocation-form>
      </div>
    </div>
  </div>
</template>

<script>
import BusinesslocationForm from "@/views/businesslocation/components/Form.vue";

export default {
  name: "add-businesslocation",
  components: {
    BusinesslocationForm,
  }
};
</script>